import {
  Button,
  CardActions,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import { apiService } from '../../../api/axiosClient';
import { MicrosoftExcel, Plus, Printer } from 'mdi-material-ui';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Page from 'src/components/Page';
import PageHeader from 'src/components/page-header';
import { getOrderNumbers } from 'src/utils/shop';
import MenuSpec from 'src/views/menu/MenuSpec';
import TableSpec from 'src/views/spec/TableSpec';
import BoxWrapper from '../../../styles/BoxWrapper';
import { onStateUpdate } from '../../../utils/orderHandler';

const SpecList = () => {
  const [reload, setReload] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [filters, setFilters] = useState({});
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const getTabValue = (index) => {
    switch(index) {  
      case 1:
        return '견적완료';
      case 2:
        return '미발주';
      default:
        return '신규견적';
    }
  }

  useEffect(() => {
    setFilters({
      ...filters,
      order_status: getTabValue(tabIndex)
    });

    setReload(reload => reload + 1);
  }, [tabIndex]);

  const sheetDownload = async () => {
      try {
          const response = await apiService.get('/proc/spec/excel', {
              params: {
                  ...filters
              },
              responseType: 'blob'
          });
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "견적리스트.xlsx";
          document.body.appendChild(a);
          a.click();
      } catch (error) {
          console.error('Error downloading spec excel:', error);
      }
  }

  const onSpecNotify = async (data) => {

    const params = {
      "userEmail": data.orderer_email,
      "orderNo": data.orderid,
      "orderDate": data.spec_time,
      "orderPrice": data.supply_price,
      "orderContact": data.orderer_contact,
      "com_id": data.com_id
    };

    try {
      const response = await apiService.post('/biztalk/estimate', params);
      toast.success('주문자에게 Biztalk으로 알림이 발송되었습니다.');
    } catch (error) {
      console.error('Error sending biztalk notification:', error);
    }
  }

  const onStateChange = async (status) => {
    selected.map((data) => {
      onStateUpdate(data, status, () => {
        toast.success('수정 되었습니다');
      });

      onSpecNotify(data);
    });

    setReload(reload => reload + 1);
  }

  return (
    <Page title="견적">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                외부견적
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              외부견적 리스트를 보여줍니다.
            </Typography>
          }
        />
        <BoxWrapper>
          <MenuSpec setFilters={setFilters} setReload={setReload}/>

          <Tabs 
            value={tabIndex} 
            onChange={(e, newValue) => setTabIndex(newValue)}
          >
            <Tab label="견적" />
            <Tab label="견적완료" />
            <Tab label="미발주" />
          </Tabs>

          <TableSpec filters={filters} submit={reload} selected={selected} setSelected={setSelected} 
            page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize}/>

          <CardActions className='card-action-dense'>
            <Stack direction="row" spacing={2}>
              <Link to={`/admin/process/spec/register`}>
                  <Button variant="contained" startIcon={<Plus />}>등록</Button>
              </Link>
            </Stack>
            <Stack direction="row" spacing={2} sx={{pl: 4}}>
              <Button variant='contained' color="warning" onClick={() => {onStateChange("견적완료")}}>견적완료</Button>
              <Button variant='contained' color="warning" onClick={() => {onStateChange("신규주문")}}>신규주문</Button>
              <Button variant='contained' color="error" onClick={() => {onStateChange("미발주")}}>미발주</Button>
            </Stack>
            <Stack direction="row" spacing={2} sx={{pl: 4}}>
              <Button component={Link} 
                to={`/form/spec?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>견적서</Button>
            </Stack>
            <Stack direction="row" spacing={2} sx={{pl: 4}}>
              <Button variant='contained' startIcon={<MicrosoftExcel />} onClick={sheetDownload}>엑셀출력</Button>
            </Stack>
          </CardActions>
          
        </BoxWrapper>
      </Grid>
    </Page>
  )
}

export default SpecList